import { useGetUserSubscription } from '@forwardflow/hooks/customHooks'
import { Skeleton } from 'antd'
import dayjs from 'dayjs'

export const NextBillingCycle = () => {
   const { data, isLoading } = useGetUserSubscription()

   return (
      <div className="flex-1">
         <p className="font-medium">Next Billing Cycle</p>
         {!isLoading ? (
            <div className="bg-[#474747]/10 px-7 py-9 min-h-80 flex flex-col justify-between mt-5 rounded-xl">
               <p className="text-[20px] font-medium">
                  {dayjs(data?.nextBillingCycle?.currentPeriodEnd).format(
                     'D MMM, YYYY'
                  )}
               </p>
               <p className="text-right text-[18px] font-medium text-primary">
                  $ &nbsp;
                  <span className="text-[30px]">
                     {data?.nextBillingCycle?.totalPrice}
                  </span>{' '}
                  &nbsp;/ month
               </p>
            </div>
         ) : (
            <div>
               <Skeleton active className="my-6" />
               <Skeleton active />
            </div>
         )}
      </div>
   )
}
